import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Curriculum from './Curriculum';

const CurriculumRoutes = ({ gradeData }) => (
  <BrowserRouter>
    <Routes>
      <Route
        path='/teachers/g/:classID/curriculum/:gradeName'
        element={<Curriculum isPublic={false} gradeData={gradeData} />}
      />
      <Route
        path='/administrators/schools/:schoolID/teachers/:teacherID/groups/:classID/curriculum/:gradeName'
        element={<Curriculum isPublic={false} gradeData={gradeData} />}
      />
      <Route
        path='/math/:gradeName'
        element={<Curriculum isPublic={true} gradeData={gradeData} />}
      />
    </Routes>
  </BrowserRouter>
);

export default CurriculumRoutes;
